import { render, staticRenderFns } from "./SportRecord.vue?vue&type=template&id=16fcfe5d"
import script from "./SportRecord.vue?vue&type=script&lang=js"
export * from "./SportRecord.vue?vue&type=script&lang=js"
import style0 from "./SportRecord.vue?vue&type=style&index=0&id=16fcfe5d&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16fcfe5d')) {
      api.createRecord('16fcfe5d', component.options)
    } else {
      api.reload('16fcfe5d', component.options)
    }
    module.hot.accept("./SportRecord.vue?vue&type=template&id=16fcfe5d", function () {
      api.rerender('16fcfe5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/health/SportRecord.vue"
export default component.exports